(function ($, window, undefined) {
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    const _ = window.mg;

    var disabledElements = [];

    _.ui.helpers = {
        renderPrice(price, paid, forceOneLine) {
            return [
                '<div class="price-component' + (paid ? ' paid' : '') + (forceOneLine ? ' force-one-line' : '') + '">',
                    '<div class="pc-price">' + price + '</div>',
                    paid ? [
                        '<div class="pc-paid">',
                            '<i class="icon icon-check"></i>',
                            '<span>' + mg.translations.Paid + '</span>',
                        '</div>'
                    ].join('') : '',
                '</div>'
            ].join('');
        }

        , disableUI(view, restore) {

            if (restore) {
                $.each(disabledElements, function(k, v) {
                    var $v = $(v);
                    if ($v.hasClass('btn') && $v.hasClass('dropdown-toggle')) {
                        $v.removeClass('disabled')
                    } else {
                        if ($v.hasClass('button')) {
                            $v.removeClass('is-disabled');
                        } else {
                            $v.prop('disabled', false);
                        }
                    }
                });
        
                disabledElements = [];
                return;
            }
            $('input,select,.button,.btn', view).filter(':not(:disabled):not(.is-disabled):not(.disabled)').each(function(k, v) {
                disabledElements.push(v);
        
                var $v = $(v);
                if ($v.hasClass('btn') && $v.hasClass('dropdown-toggle')) {
                    $v.addClass('disabled')
                } else {
                    if ($v.hasClass('button')) {
                        $v.addClass('is-disabled');
                    } else {
                        $v.prop('disabled', true);
                    }
                }
            });
        }
        , isCharacterKeyPress(evt) {
            var tab_key_code = 9;
            const keycode = evt.keyCode ?? tab_key_code;
            //Notice: This is not a complete implementation.
            if (keycode<=46 && ((keycode >= 37 && keycode <= 40) || (keycode >= 16 && keycode <= 18 ) || keycode==8 || keycode==9  || (keycode >= 33 && keycode <= 36 ) || keycode==46 || keycode==45)) {
                return false;
            }
            return true;
         
        }

    }

})(jQuery, window);
